import { render, staticRenderFns } from "./productcenter.vue?vue&type=template&id=b278d752&scoped=true&"
import script from "./productcenter.vue?vue&type=script&lang=js&"
export * from "./productcenter.vue?vue&type=script&lang=js&"
import style0 from "./productcenter.vue?vue&type=style&index=0&id=b278d752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b278d752",
  null
  
)

export default component.exports